"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BasisTheoryTenants", {
  enumerable: true,
  get: function () {
    return _BasisTheoryTenants.BasisTheoryTenants;
  }
});

var _BasisTheoryTenants = require("./BasisTheoryTenants");